import { Fragment, useEffect, useState } from 'react';

import { PriceService as Service } from './PriceService';
import { FormatDisplay } from '../../../shared/format';
import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';
import { GroupProductService } from '../nhom-san-pham/GroupProductService';
export const List = () => {

  const header = 'Danh mục bảng giá ';
  const dataKey = 'id';
  const [groupProducts, setGroupProduct] = useState([]);
  useEffect(() => {
    GroupProductService.getAll().then((items) => {
      const _groupProducts = [];
      items.forEach((item) => {
        _groupProducts.push({ value: item.id, label: item.name });
      });
      setGroupProduct(_groupProducts);
    });

  }, []);

  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'order', header: 'Thứ tự', width: 160, matchMode: 'equals' },
      { field: 'name', header: 'Loại', width: 260, matchMode: 'contains' },
      {
        field: 'inPrice', header: 'Mua vào', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.inPrice, { maximumSignificantDigits: `${rowData.inPrice}`.length })
        }, style: { justifyContent: 'end' }
      },
      {
        field: 'outPrice', header: 'Bán ra', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.outPrice, { maximumSignificantDigits: `${rowData.outPrice}`.length })
        }, style: { justifyContent: 'end' }
      }
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { render: renderDialogCrup, create, update, clone } = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      { field: 'groupId', header: 'Nhóm hàng hóa', required: true, type: 'Dropdown', DropdownProps: { options: groupProducts, filter: true }, className: 'md:col-6' },
      { field: 'name', header: 'Loại hàng', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-12' },
      { field: 'inPrice', header: 'Mua vào', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'outPrice', header: 'Bán ra', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'order', header: 'Sắp xếp', type: 'InputNumber', InputNumberProps: { min: 0, maxFractionDigits: 6 }, className: 'md:col-6' },
      { field: 'showPrice', header: 'Sử dụng', type: 'Checkbox', className: 'md:col-6 pt-6' }
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
